import logo from './logohotel.png';
import bg from './frente2.jpg';
import pool from './piscina2.jpg';
import q1 from './quarto.jpeg';
import q2 from './quarto2.jpeg';
import q3 from './quarto5.jpg';
import q4 from './quarto4.jpg';

import Component from './Carousel';
import * as Style from './style';
import { MdHotel, MdRestaurant, MdPool, MdWifi } from "react-icons/md";

import './App.css';

function App() {
  return (
    <>
    <Style.Header>
      <img src={logo} className="App-logo" alt="logo" />
    </Style.Header>
    <Style.Deco />
    <Style.Container className="App">
      <Component/>
        <div className="main">
        <p className="title">
          Seja bem-vindo ao<br />
          <span>Olympia Hotel</span>
          <div className="icons">
            <MdHotel/>
            <MdRestaurant/>
            <MdPool/>
            <MdWifi/>
          </div>
          <Style.StyledBox>
          <div>
            <h4 className="article">
            Localizado em Lorena, O Olympia Hotel é conhecido pela sua acomodação aconchegante e familiar.
            Todos nossos quartos estão equipados com uma mesa de trabalho, TV de tela plana, banheiro privativo, ar-condicionado, guarda-roupa e frigobar.
            Além do serviço de quarto, o hotel oferece uma piscina ao ar livre aos seus hóspedes aberta o ano todo, Wi-fi grátis e um estacionamento gratuito privado. Além disso, possuímos uma lavanderia com custo adicional.
            Temos um salão de eventos para mais de 100 pessoas para fazer seu evento, além de uma sala de reuniões.
            O Restaurante Don Martins se encontra dentro do espaço do Olympia Hotel, oferecendo uma culinária mediterrânea com menu á la carte.
            </h4>
          </div>
          {/* <div>
            <h4 className="form">
            Faça sua reserva aqui!
            Nos envie um e-mail e retornaremos pra você.
            </h4>
          </div> */}
          </Style.StyledBox>
        </p>
        <Style.Deco />
        <Style.StyledBox>
			<Style.ImgBox>
				<img src={q1} className="App-logo" alt="logo" /> 
			</Style.ImgBox>
			<Style.ImgBox>
				<img src={q3} className="App-logo" alt="logo" />
			</Style.ImgBox>
			<Style.ImgBox>
				<img src={q2} className="App-logo" alt="logo" />
			</Style.ImgBox>
			<Style.ImgBox>
				<img src={q4} className="imgBox" alt="logo" />
			</Style.ImgBox>
      	</Style.StyledBox>
		  		  

        </div>
		<Style.Footer>
				<p>
					R. Maj. Joaquim Luíz Bastos, 96 - Centro, Lorena - SP, 12606-090
				</p>    
				<a href="tel: 1231532924">(12) 3153-2924</a>
			</Style.Footer>
			</Style.Container>
    </>
  );
}

export default App;
